<template>
  <div class="page">
    <div class="jumbotron jumbotron-fluid">
      <div class="container">
        <h1 class="display-1">Strona nie znaleziona</h1>
      </div>
    </div>
  </div>
</template>
